import React from "react";
import { Row, Col } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ParkMainOverViewSkeleton = () => {
  return (
    <Row className="justify-content-center">
      <Col lg={10} xs={12}>
        <Row className="mb-2">
          <Col xxl={3} xl={3} lg={3} style={{ borderBottom: "1px solid #0000004D" }}>
          <div className="tiger_images w-100">
            <Skeleton height={100} className="w-100 h-100"    style={{borderRadius: "30px", border: "8px solid #f5f5f5;"}}/>
            </div>
          </Col>
          <Col
            xl={9}
            lg={9}
            className="pt-4"
            style={{ borderBottom: "1px solid #0000004D" }}
          >
            <div className="main_parent d-flex justify-content-between">
              <div className="title d-flex gap-4 align-items-center">
                <Skeleton width={300} height={28} />
                <Skeleton width={70} height={30} />
              </div>
              <div className="right_button float-lg-end pb-2 d-lg-block d-flex justify-content-end">
                <Skeleton width={25} height={30} />
              </div>
            </div>

            <div className="detailesOrLocation">
              <Row>
                {[...Array(8)].map((_, i) => (
                  <Col
                    key={i}
                    xl={4}
                    md={4}
                    sm={6}
                    xs={12}
                    className="mb-3"
                  >
                    <div className="items_bg d-flex gap-2 align-items-center">
                      <Skeleton  width={20} height={20} />
                      <div className="d-flex flex-column w-100">
                        <Skeleton width={100} height={12} />
                        <Skeleton width="80%" height={14} />
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ParkMainOverViewSkeleton;
